export default "__VITE_ASSET__MOA8jaBe__"